import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';

const ButtonStyle = {
  padding: 3,
  lineHeight: 1,
  minWidth: 71,
  textTransform: 'unset'
};

const IconStyle = {
  width: 24,
  margin: '4px 0'
};

const RemoteButton = props => {
  const { intl, style, onClick } = props;

  return (
    <Button color="primary" onClick={onClick} style={{ ...ButtonStyle, ...style }}>
      <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <Grid>
          <img src="img/icons/whiteboard_pen_active_color.svg" alt="whiteboard" style={IconStyle} />
        </Grid>
        <Grid>
          <Typography align="center" color="textSecondary">
            {intl.formatMessage({ id: 'fin-py-remote' })}
          </Typography>
        </Grid>
      </Grid>
    </Button>
  );
};

export default injectIntl(RemoteButton);
